import { render, staticRenderFns } from "./ChartResolutions.vue?vue&type=template&id=c3748a98&scoped=true&"
import script from "./ChartResolutions.vue?vue&type=script&lang=js&"
export * from "./ChartResolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3748a98",
  null
  
)

export default component.exports